import FooterHeading from "./__simple/_footerHeading";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import config from '../configuration/config';
import Joi from 'joi';
import { toast } from "react-toastify";
import { setReduxBrands } from '../_redux/slices/dataSlice';
import { useDispatch, useSelector } from 'react-redux';
function Footer() {
    const { t: trans, i18n } = useTranslation("common");
    const dispatch = useDispatch();
    const reduxBrands = useSelector((state) => state.apiData.data.reduxBrands); // Access Redux state
    const [brands, setBrands] = useState([]);
    const [socials, setSocials] = useState([]);
    const [email, setEmail] = useState('');
    const submitEmail = async (e) => {
        e.preventDefault();

        const schema = Joi.object({
            email: Joi.string().required().email({ minDomainSegments: 2, tlds: { allow: false } })
        });
        const { error } = schema.validate({ email: email });
        if (error == null) {
            if (!(await isEmailExisted(email))) {
                axios.post(
                    `${config.controllURL}${i18n.language || 'ar'}/api/Pages/AddsiteNewslettterSub`,
                    {
                        "email": email
                    }
                ).then((response) => {
                    if (response.status == 200) {
                        toast.success(trans("common:email-register-in-news"))
                        setEmail('');
                    }
                });
            } else {
                toast.error(trans("common:email-existed"));
            }
        }
    };

    async function isEmailExisted(email) {
        let isExisted = false;
        try {
            const response = await axios.post(
                `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailssiteNewslettterSub`,
                {
                    "ObjectSettings": {
                        "MetaData": false
                    },
                    "Filters": `where lower(email) = lower('${email}')`
                }
            );
            isExisted = response.data.ApiObjectData.length > 0;
        } catch (err) {
            console.log(err);
        }
        return isExisted;
    }


    let lang = (i18n.language || 'ar');

    useEffect(async () => {


        if (reduxBrands?.length > 0 && brands?.length <= 0) {

            setBrands(reduxBrands);
        }
        if (brands?.length > 0 && reduxBrands?.length <= 0) {
            dispatch(setReduxBrands(brands));
        }
    }, [reduxBrands, brands]);
    useEffect(async () => {
        try {

            if (!(reduxBrands?.length > 0)) {

                const res = await axios.request({
                    baseURL: config.controllURL,
                    url: lang + "/api/brands/brands",
                    method: "get",

                })
                setBrands(res.data.brands);
            }

            const social = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/contact/social",
                method: "get",

            })
            setSocials(social.data);
        } catch (error) {
        }

    }, []);


    return (
        <footer className="footer">
            <div className="footer-top py-12 container  ">



                <div className="footer-top-links">
                    <ul className={"bold"}>
                        <li><Link to="/">{trans("home")}</Link></li>
                        {brands.map((brand) => (
                            <li key={brand.brand}><Link to={"/vehicles/" + brand.brand}>{brand.brand}</Link></li>
                        ))}
                        <li><Link to="/maintenance">{trans("maintenance-services")}</Link></li>
                        <li><Link to="/finance">{trans("finance")}</Link></li>
                    </ul>
                    <ul className={"normal"}>
                        <li><Link to="/recruitment">{trans("employment")}</Link></li>
                        <li><Link to="/news">{trans("news")}</Link></li>
                        <li><Link to="/about">{trans("about-us")}</Link></li>
                        <li><Link to="/order-car">{trans('buy-vehicle')}</Link></li>
                    </ul>
                    <ul className={"normal"}>
                        <li><Link to="/hj/advises">{trans("HJ-advises")}</Link></li>
                        <li><Link to="/contact">{trans("locations")}</Link></li>
                        <li><Link to="/contact">{trans('contact-us')}</Link></li>
                        <li><Link to="/websitePolicy">{trans('common:website-policy')}</Link></li>
                    </ul>
                </div>

                <div className="footer-mobile-bottom-row">
                    <div className="footer-top-left-group">
                        <div className="footer-apps-section">
                            <div className={"footer-top-imgs-links"}>
                                <a target="_blank" rel="noreferrer" href={"https://apps.apple.com/sa/app/hassan-jameel-motors/id6751719846"} className="footer-store-btn">
                                    <div className="store-icon">
                                        <img src="/assets/icons/apple-store.svg" alt="app store" />
                                    </div>
                                    <div className="store-text">
                                        <span className="store-sub">{trans("get_in_on")}</span>
                                        <span className="store-main">{trans("app_store")}</span>
                                    </div>
                                </a>
                                <a target="_blank" rel="noreferrer" href={"https://play.google.com/store/apps/details?id=com.hassanjameel.app"} className="footer-store-btn">
                                    <div className="store-icon">
                                        <img src="/assets/icons/google-play.svg" alt="play store" />
                                    </div>
                                    <div className="store-text">
                                        <span className="store-sub">{trans("get_in_on")}</span>
                                        <span className="store-main">{trans("google_play")}</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="footer-top-social">
                        <FooterHeading lang={lang} title={trans('fallow-us')} />
                        <div className={"footer-top-social-links"}>
                            {
                                socials.map((social) => {
                                    return (
                                        <a target="_blank" rel="noopener" href={social.content} aria-label={social.name}
                                            key={social.name}
                                            className="social-box">
                                            <img data-src={config.FilePathURL + social.imagePath} className={"lazyload object-full object-contain"}
                                                alt={social.name} />
                                        </a>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom flex justify-between items-center py-2 px-6 container-p">
                <div>
                    <a className={"text-16 no-hover"} href="./">® {new Date().getFullYear()} "{trans('HJ-for-cars')}"</a>
                </div>
                <div className={"space-x-2 space-x-reverse"}>
                    <Link className={"text-16"} to="/privacy">{trans('privacy-policy')}</Link>
                    {/* <a className={"text-16"} href="./"> {trans('site-policy')} </a> */}
                </div>
            </div>
        </footer>
    );
}

export default Footer;